import InvestorProjectLayout from "./InvestorProjectLayout"

export default InvestorProjectLayout
